import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PointState } from "./types";
import { Point as PointType } from "@/types";

export const initialState: PointState = {
  data: null,
  currentPoint: null,
  loading: false,
  error: null,
};

const pointSlice = createSlice({
  name: "point",
  initialState,
  reducers: {
    setPoints: (state: PointState, action: PayloadAction<PointType[]>) => {
      state.data = action.payload;
    },
    fetchPointStart: (state: PointState) => {
      state.loading = true;
      state.error = null;
    },
    fetchPointSuccess: (
      state: PointState,
      action: PayloadAction<PointType>
    ) => {
      state.loading = false;
      state.currentPoint = action.payload;
      state.error = null;
    },
    fetchPointFailure: (state: PointState, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearCurrentPoint: (state: PointState) => {
      state.currentPoint = null;
    },
    fetchPoint: (
      state: PointState,
      action: PayloadAction<{ id: string; brandId: string }>
    ) => {
      // This action will be handled by saga
    },
  },
});

const persistConfig = {
  key: "point",
  storage,
  whitelist: ["data", "currentPoint"],
};

export const {
  setPoints,
  fetchPointStart,
  fetchPointSuccess,
  fetchPointFailure,
  clearCurrentPoint,
  fetchPoint,
} = pointSlice.actions;

export const pointReducer = pointSlice;
export default persistReducer(persistConfig, pointSlice.reducer);
